// import { DefaultAzureCredential } from "@azure/identity";
import ARFData from "../viewModels/ARFData";
import RestUtilities from "./Base";
// import AzureStorageBlob from "@azure/storage-blob";

export default class ARF {
  static async submit(arf: ARFData) {
    return RestUtilities.post("/api/arf/submit", arf, true);
  }
}
